import React from 'react';
import { useParams } from 'react-router-dom';
import { HierarchyBrowser } from '../components/HierarchyBrowser';

const CategoryDetailPage: React.FC = () => {
  const { categoryName } = useParams<{ categoryName: string }>();
  const decodedCategory = categoryName ? decodeURIComponent(categoryName) : '';

  if (!decodedCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-900">Category not specified</p>
          <p className="text-gray-600 mt-2">Please go back and select a category</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10">
      <div className="max-w-7xl mx-auto px-4">
        <HierarchyBrowser initialCategoryName={decodedCategory} />
      </div>
    </div>
  );
};

export default CategoryDetailPage;

